import Introduce3D from "../../../../src/events/2022/12/3d-introduce/main";
import * as React from 'react';
export default {
  Introduce3D,
  React
};